(() => {
  const triggerSelector = '[data-tl-chat-trigger]';
  const pendingTriggers = new Map();
  let chatObserver = null;

  const getChat = () => document.querySelector('shopify-chat');

  const openChat = (chat, trigger) => {
    chat.setAttribute('open', '');
    trigger?.removeAttribute('aria-busy');
  };

  const stopWatchingIfIdle = () => {
    if (pendingTriggers.size || !chatObserver) return;
    chatObserver.disconnect();
    chatObserver = null;
  };

  const resolvePending = () => {
    const chat = getChat();
    if (!chat) return;
    pendingTriggers.forEach((timeoutId, trigger) => {
      window.clearTimeout(timeoutId);
      openChat(chat, trigger);
    });
    pendingTriggers.clear();
    stopWatchingIfIdle();
  };

  const watchForChat = (trigger) => {
    trigger.setAttribute('aria-busy', 'true');
    const existingTimeoutId = pendingTriggers.get(trigger);
    if (existingTimeoutId) {
      window.clearTimeout(existingTimeoutId);
    }
    if (!chatObserver) {
      chatObserver = new MutationObserver(resolvePending);
      chatObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    const timeoutId = window.setTimeout(() => {
      trigger.removeAttribute('aria-busy');
      pendingTriggers.delete(trigger);
      stopWatchingIfIdle();
    }, 5000);
    pendingTriggers.set(trigger, timeoutId);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const trigger = target?.closest(triggerSelector);
    if (!trigger) return;
    event.preventDefault();
    const chat = getChat();
    if (chat) openChat(chat, trigger);
    else watchForChat(trigger);
  });
})();
